const OPTGROUPS = {
  user: '--User',
  app: '-- Application',
  date: '-- Date',
};

const FILTERS = [
  {
    id: 'app.id',
    label: 'Platform',
    optgroup: 'app',
    input: 'select',
    values: {
      'com.gasbuddymobile.gasbuddy': 'iOS Consumer Mobile',
      'gbis.gbandroid': 'Android Consumer Mobile',
    },
    operators: ['equal', 'not_equal'],
  }, {
    id: 'app.ver',
    label: 'Application Version',
    type: 'string',
    optgroup: 'app',
  }, {
    id: 'app.hr',
    label: 'Hours since install',
    type: 'integer',
    input: 'number',
    optgroup: 'app',
  }, {
    id: 'user.country',
    label: 'User Country',
    type: 'string',
    optgroup: 'user',
  }, {
    id: 'user.region',
    label: 'User Region',
    type: 'string',
    optgroup: 'user',
  }, {
    id: 'now',
    label: 'Current Date (use iso-date:xxx)',
    type: 'string',
    optgroup: 'date',
    operators: [
      'less',
      'less_or_equal',
      'greater',
      'greater_or_equal',
    ],
  },
];

const REQUESTS = [
  {
    user: {
      country: 'US',
      anon_id: 'fake-anonymous-user-id',
    },
    app: {
      id: 'com.gasbuddymobile.gasbuddy',
      ver: '5.4.0',
    },
    locale: 'en-CUS',
    dev: {
      id: '317F3E25-5D2A-4C79-8988-BE230DD047E1',
      os: 'iOS',
      ver: '11.0',
    },
  }, {
    app: {
      id: 'gbis.gbandroid',
      ver: '21006',
    },
    dev: {
      id: '61569a6f429c2c1f',
      os: 'android',
      ver: '26',
    },
    locale: 'en_us',
    user: {
      anon_id: 'fake-andoid-user-id',
      country: 'CA',
    },
  },
];

export default {
  REQUESTS,
  FILTERS,
  OPTGROUPS,
};
